export type TPaymentStatus = EPaymentStatus | null;

export enum EPaymentStatus {
  Pending = 'pending',
  Success = 'succeeded',
  Fail = 'canceled',
}

export interface IDepositAccountState {
  recommendedPackagePaymentStatus: TPaymentStatus;
  paymentStatus: TPaymentStatus;
  paymentToken: string | null;
}
